import { useContext } from "react";
import { Button, Icon } from "@mui/material";
import { AuthContext } from "src/utils/AuthContext.js";
import { trackPrintableScheduleEvent } from "./printableSchedule.js";

/**
 * Opens the calendar's creator-uploaded schedule PDF in a new tab; renders nothing without one.
 * @param {{ calendar: object, surface: 'timeline' | 'share_dialog', fullWidth?: boolean, sx?: object }} props
 * @returns {JSX.Element | null}
 */
export default function PrintScheduleButton({ calendar, surface, fullWidth = false, sx }) {
  const { user } = useContext(AuthContext);
  const url = calendar?.printableSchedule?.url;
  if (!url) return null;

  return (
    <Button
      data-testid={`print-schedule-button-${surface}`}
      component="a"
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      variant="outlined"
      size="shrinked"
      fullWidth={fullWidth}
      startIcon={<Icon baseClassName="material-symbols-outlined">print</Icon>}
      sx={sx}
      onClick={() =>
        trackPrintableScheduleEvent({
          name: "printable_schedule_downloaded",
          label: "Printable Schedule Download Click",
          user,
          calendar,
          surface,
        })
      }
    >
      Print schedule
    </Button>
  );
}
